import React, { useEffect, useState } from 'react';

import { Formik, FormikProvider } from 'formik';

import { withErrorBoundary } from 'components/shared/Error/Boundary';

import AppointmentContent from './AppointmentContent';
import useAppointmentRescheduled from './hooks/useAppointmentRescheduled';
import useAppointmentUpdate from './hooks/useAppointmentUpdate';
import { UpdateAppointmentValidationSchema } from './lib/validationSchemas';

const AppointmentFormik = ({
  handleClose,
  appointment,
  isLoading,
  isUnsaved,
  setIsUnsaved,
  setFormikValues,
  setAppointmentId
}) => {
  const [formValues, setFormValues] = useState(appointment);

  useAppointmentRescheduled({ propsAppointment: appointment, handleClose });

  const { mutateAppointment } = useAppointmentUpdate({
    appointment,
    handleClose,
    setAppointmentId
  });

  useEffect(() => {
    if (appointment) {
      setFormValues(appointment);
    }
  }, [appointment]);

  useEffect(() => {
    if (!isLoading && appointment === -1) {
      //appointment not found
      handleClose();
    }
  }, [isLoading, appointment]);

  return (
    <Formik
      enableReinitialize
      initialValues={formValues}
      onSubmit={(values) => mutateAppointment(values)}
      validationSchema={UpdateAppointmentValidationSchema}>
      {(formikProps) => (
        <FormikProvider
          value={{ ...formikProps, setAppointmentId, handleCloseEncounterModal: handleClose }}>
          <AppointmentContent
            {...{
              handleClose,
              appointment,
              setFormValues,
              isLoading,
              isUnsaved,
              setIsUnsaved,
              setFormikValues,
              setAppointmentId
            }}
          />
        </FormikProvider>
      )}
    </Formik>
  );
};
export default withErrorBoundary(AppointmentFormik);
